import { EarningsScenarioResponse } from '@api/api/earnings';
import { useTranslation } from 'react-i18next';

import { EarningState, Expectation } from '../../types';
import { formatEarning, getEarningState } from '../../utils';
import styles from './ChartTitle.module.scss';

export interface ChartTitleProps {
  count?: number;
  expectation: Expectation;
  earningsData: EarningsScenarioResponse;
}

export const ChartTitle = ({
  count,
  expectation,
  earningsData,
}: ChartTitleProps) => {
  const { t } = useTranslation();
  const { eps, currency, reported, ticker } = earningsData;

  const valueFormatted = formatEarning(eps, currency);

  if (reported) {
    const earningsState = getEarningState(eps);

    return (
      <div className={styles.chartTitleRoot} data-testid="chart-title-reported">
        {earningsState === EarningState.Beat &&
          t('earnings:chart.titleReportedBeats', {
            ticker,
            count,
            value: valueFormatted,
          })}

        {earningsState === EarningState.Miss &&
          t('earnings:chart.titleReportedMisses', {
            ticker,
            count,
            value: valueFormatted,
          })}

        {earningsState === EarningState.Meet &&
          t('earnings:chart.titleReportedMeet', {
            ticker,
          })}
      </div>
    );
  }

  return (
    <div className={styles.chartTitleRoot} data-testid="chart-title">
      {t('earnings:chart.title', {
        count,
        ticker,
        expectation:
          expectation === Expectation.Beat
            ? t('common:beats', { count })
            : t('common:misses', { count }),
      })}
    </div>
  );
};
